import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import MainButton from "./landingpage/MainButton";
import Container from "../shared/Container";
import styles from "./Nav.module.css";
import logo from "../../assets/shared/dishonline-logo-white.png";

const NavAdmin = () => {
   const [menuOpen, setMenuOpen] = useState(false);
   const isLoggedIn = localStorage.getItem("token"); // Check if user is logged in

   // Functie om menu te openen/sluiten
   const toggleMenu = () => {
      setMenuOpen(!menuOpen);
   };

   // Functie om het menu te sluiten als er naar een andere pagina wordt genavigeerd
   const closeMenu = () => {
      setMenuOpen(false);
   };

   // Voorkom scrollen op de achtergrond wanneer menu open is
   useEffect(() => {
      if (menuOpen) {
         document.body.style.overflow = 'hidden';
      } else {
         document.body.style.overflow = 'auto';
      }

      return () => {
         document.body.style.overflow = 'auto';
      };
   }, [menuOpen]);

   return (
      <nav> 
         <Container>
            <div className={styles.nav}>
               {/* Logo */}
               <div className="mxw-200">
                  <NavLink to="/">
                     <img
                        src={logo}
                        alt="DishOnline Logo"
                        className={styles.logo}
                     />
                  </NavLink>
               </div>

               {/* Hamburger Icon */}
               <div
                  className={`${styles.hamburger} ${menuOpen ? styles.open : ""}`}
                  onClick={toggleMenu}
                  aria-label="Toggle menu"
               >
                  <span></span>
                  <span></span>
                  <span></span>
               </div>

               {/* Menu Items - Always in the DOM for proper animation */}
               <div
                  className={`${styles.navLinks} ${menuOpen ? styles.open : ""}`}
               >
                  <a href="#features" className="t-h-d-u" onClick={closeMenu}>
                     Features
                  </a>
                  <a href="#faq" className="t-h-d-u" onClick={closeMenu}>
                     Veelgestelde vragen
                  </a>
                  {!isLoggedIn && (
                     <NavLink
                        to="/inloggen"
                        className="t-h-d-u"
                        onClick={closeMenu}
                     >
                        Inloggen
                     </NavLink>
                  )}
                  {isLoggedIn ? (
                     <NavLink to="/dashboard" onClick={closeMenu}>
                        <MainButton fontSize="16px">Ga naar Dashboard</MainButton>
                     </NavLink>
                  ) : (
                     <a 
                        href="mailto:info@brandvisionx.be?subject=Interesse%20in%20Resto-Online%20Webshop&body=Hallo%20Resto-Online%2C%0A%0AIk%20ben%20ge%C3%AFnteresseerd%20in%20het%20aanmaken%20van%20een%20online%20bestelwebshop%20voor%20mijn%20restaurant.%0A%0AAlvast%20bedankt%20voor%20de%20informatie%2C%0A%0AMet%20vriendelijke%20groeten%2C" 
                        onClick={closeMenu}
                     >
                        <MainButton fontSize="16px">Maak een webshop</MainButton>
                     </a>
                  )}
               </div>
            </div>
         </Container>
      </nav>
   );
};

export default NavAdmin;